import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import classNames from "classnames";
import isNumber from "lodash/isNumber";
import { useEffect, useState } from "react";
const TOAST_COLOR_CLASS_NAMES = {
    black: "bg-pigeon-700 text-white",
    red: "bg-flamingo-600 text-white"
};
export const ToastItem = (param)=>{
    let { children, color = "black", onDismiss, prefix, suffix, timeBeforeAutoDismiss, type, withCloseButton } = param;
    const [isHovered, setIsHovered] = useState(false);
    useEffect(()=>{
        let timer = 0;
        if (isNumber(timeBeforeAutoDismiss) && !isHovered) {
            timer = window.setTimeout(onDismiss, timeBeforeAutoDismiss);
        }
        return ()=>clearTimeout(timer);
    // dismiss as dependency causes issue with resetting the timeout
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isHovered,
        timeBeforeAutoDismiss
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("relative my-1 flex min-h-[48px] items-center gap-3 overflow-hidden rounded-lg px-4 py-3 shadow-popover", TOAST_COLOR_CLASS_NAMES[color]),
        "data-testid": "TOAST_ITEM",
        role: type === "assertive" ? "alert" : "status",
        onPointerEnter: ()=>setIsHovered(true),
        onPointerLeave: ()=>setIsHovered(false),
        children: [
            !!prefix ? /*#__PURE__*/ _jsx("div", {
                className: "shrink-0",
                "data-testid": "TOAST_PREFIX",
                children: prefix
            }) : null,
            /*#__PURE__*/ _jsx("span", {
                className: "text-14 font-medium",
                "data-testid": "TOAST_TEXT",
                children: children
            }),
            !!suffix ? /*#__PURE__*/ _jsx("div", {
                className: "shrink-0",
                "data-testid": "TOAST_PREFIX",
                children: suffix
            }) : null,
            withCloseButton && /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                color: "grey",
                className: "shrink-0 text-white/80",
                icon: Close,
                label: "Close toast",
                onClick: onDismiss,
                size: "small"
            })
        ]
    });
};
